export {};
//# sourceMappingURL=transform-fn-params.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/class-transformer/esm5/interfaces/metadata/transform-fn-params.interface.js
// module id = 798
// module chunks = 3